export const getCardStyles = {
	position: 'relative', // must be non-static because of the AspectRatioPaddingBox
	border: 'none',
	boxShadow: 'none',
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
};

export const getPaddingBoxStyles = {
	borderRadius: 2,
	paddingBottom: '119%',
	position: { xs: 'relative', md: 'relative' },
	overflow: 'hidden',
};

export const getImageWrapperStyles = {
	display: 'flex',
	justifyContent: 'center',
	overflow: 'hidden',
	maxWidth: '900px',
	maxHeight: '900px',
	'& img': {
		objectFit: 'cover',
	},
};

export const getIconContainerStyles = ({ height }: { height: number }) => ({
	height,
});

export const getIconStyles = {
	fontSize: 160,
	color: 'neutrals.white',
};

export const getCardContentStyles = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'flex-start',
	pt: 2.5,
	pl: 0,
};

export const getJobTitleStyles = {
	pt: 2,
};

export const getCollegeNameStyles = {
	pt: 0.5,
};

export const getProviderButtonStyles = {
	marginY: '1.5rem',
};

export const getProviderPopLinkStyles = {
	padding: '0',
	marginY: '.5rem',
	color: 'primary.light',
};
